import { render, staticRenderFns } from "./CropCard.vue?vue&type=template&id=d8df54e8"
import script from "./CropCard.vue?vue&type=script&lang=js"
export * from "./CropCard.vue?vue&type=script&lang=js"
import style0 from "./CropCard.vue?vue&type=style&index=0&id=d8df54e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports